import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { WBYH_CARDS } from "@/lib/data";

export default function WhatBringsYouHere() {
  return (
    <section className="dyntra-container mt-10">
      <SectionHeading title="What Brings You Here?" testid="wbyh-heading" />
      {/* The WBH illustrations already contain their own titles, subtitles,
          badges and CTA buttons baked into the image, so we render the image
          as the tile itself. The wrapping <Link> makes the whole tile
          clickable and routes to the first action's href — this preserves
          the routing intent for cards that previously exposed multiple
          buttons (e.g. Hire Hub → /staffing?mode=candidate). */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 mt-6">
        {WBYH_CARDS.map((c) => {
          const primaryHref = c.actions?.[0]?.href || "/";
          return (
            <Link
              key={c.id}
              to={primaryHref}
              data-testid={`wbyh-card-${c.id}`}
              aria-label={c.title}
              className="group relative block aspect-[1016/1548] rounded-2xl overflow-hidden bg-white border border-gray-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(75,42,173,0.16)]"
            >
              <img
                src={c.image}
                alt={c.title}
                loading="lazy"
                className="w-full h-auto block transition-transform duration-500 group-hover:scale-[1.03]"
              />
            </Link>
          );
        })}
      </div>
    </section>
  );
}

export function SectionHeading({ title, subtitle, href, testid }) {
  return (
    <div className="flex items-end justify-between">
      <div>
        <h2 data-testid={testid} className="font-display text-2xl sm:text-3xl font-bold text-gray-900">{title}</h2>
        {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
      </div>
      {href && (
        <Link to={href} data-testid={`${testid}-view-all`} className="text-sm font-semibold text-[#4B2AAD] hover:underline flex items-center gap-1">
          View All <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      )}
    </div>
  );
}
